import React, { useRef, useEffect } from 'react';
import {TextField} from "@fluentui/react";

const ATextField = (props)=>{
    const aTextFieldRef = useRef(null);

    useEffect(() => {
        if (aTextFieldRef.current && props.autoFocus && props.autoFocus === true) {
            aTextFieldRef.current.focus(); // Programmatically sets focus
        }
    }, []);
    return (<>
        <div className={props.parentClassName}>
            <TextField
                className={props.className}
                styles={props.styles}
                label={props.label}
                placeholder={props.placeholder}
                name={props.name}
                value={props.value}
                onBlur={props.onBlur}
                onChange={props.onChange}
                autoComplete="off"
                errorMessage={
                 props.errorMessage
                }
                componentRef={aTextFieldRef}
                disabled={props.disabled ? props.disabled : false}
                required={props.required}
              />
        </div>
    </>)
}

export default ATextField;